// Pure helpers for the [[1]], [[2]]... blank markers of a fill-in-the-blank question.

const MARKER = /\[\[\d+\]\]/g;

/** Number of blank markers in the text. */
export function blankCount(text: string): number {
  return (text.match(MARKER) ?? []).length;
}

/** Rewrites every marker as [[1]], [[2]]... in reading order. */
export function renumber(text: string): string {
  let n = 0;
  return text.replace(MARKER, () => `[[${++n}]]`);
}

/** If the cursor falls strictly inside a [[n]] marker, moves it to just after that marker. */
export function snapCursor(text: string, cursor: number): number {
  for (const m of text.matchAll(MARKER)) {
    const start = m.index ?? 0;
    const end = start + m[0].length;
    if (cursor > start && cursor < end) return end;
  }
  return cursor;
}

/** Inserts a blank at the cursor, renumbers all markers, and returns the cursor just after the new one. */
export function insertBlank(text: string, cursor: number): { text: string; cursor: number } {
  const at = snapCursor(text, Math.max(0, Math.min(cursor, text.length)));
  const before = renumber(`${text.slice(0, at)}[[0]]`);
  const after = text.slice(at);
  return { text: renumber(before + after), cursor: before.length };
}
